import React from "react";

export default function BenebonoInstagram() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0307 0.210449L24.4689 0.497903C26.8021 1.16363 28.6935 3.04178 29.3954 5.35904L29.7067 6.88624V22.5004C29.3566 26.1139 26.4794 28.9602 22.8349 29.1789L7.55801 29.1762C3.90477 28.939 0.988708 26.0037 0.740927 22.3585L0.738281 7.082C0.914638 3.51969 3.85716 0.48644 7.41604 0.210449H23.0307ZM7.40458 2.65998C5.19218 2.91921 3.43302 4.71359 3.17995 6.92152L3.17377 22.4149C3.4145 24.7022 5.25743 26.5406 7.55537 26.7461L22.9452 26.7435C25.2396 26.5116 27.0649 24.6528 27.2765 22.362L27.2739 6.97266C27.0331 4.70566 25.2263 2.87601 22.9461 2.64499L7.40546 2.66086L7.40458 2.65998Z"
        fill="#EA6525"
      />
      <path
        d="M20.524 9.82529C24.2895 13.4574 22.6699 19.7808 17.5822 21.2502C11.9032 22.8902 6.76873 17.6373 8.82011 12.2615C10.588 7.62746 16.8947 6.32364 20.524 9.82529ZM14.9144 10.1448C11.6327 10.455 9.75302 14.0412 11.2807 16.837C13.2237 20.3913 18.7952 19.9188 20.0021 16.0717C21.0182 12.8335 18.379 9.81693 14.9144 10.1448Z"
        fill="#EA6525"
      />
      <path
        d="M23.3036 5.29345C25.5942 5.23183 25.7661 8.1316 23.6279 8.32907C21.0394 8.56812 20.8605 5.35878 23.3036 5.29345Z"
        fill="#EA6525"
      />
    </svg>
  );
}
